import { render, staticRenderFns } from "./NewsDisplay.vue?vue&type=template&id=1cf06bcc&scoped=true"
import script from "./NewsDisplay.vue?vue&type=script&lang=js"
export * from "./NewsDisplay.vue?vue&type=script&lang=js"
import style0 from "./NewsDisplay.vue?vue&type=style&index=0&id=1cf06bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf06bcc",
  null
  
)

export default component.exports